import { Controller } from '@hotwired/stimulus';

import Searcher from '@/modules/searcher';
import Templates from '@/pages/site/templates';

import { isPresent } from '@/modules/helper';

Handlebars.registerPartial('rhythm', Templates._rhythm);

export default class extends Controller {
  static targets = ['gridyUrl'];

  connect() {
    this.grid = $('[data-gridy]');

    new Searcher(this.grid, Templates.rhythms.gridy, this.searchOptions()).create();
  }

  searchOptions() {
    return {
      before: (search) => {
        const title = document.querySelector('[data-title]').dataset.title;

        document.querySelector('[data-search-term]').textContent = isPresent(search) ? search : title;
      },

      idSortName: 'rhythms.total_of_votes',
      idSortOrder: 'desc',
      sortName: 'rhythms.teachers_count',
      sortOrder: 'desc',
      url: this.gridyUrlTarget.value,
    };
  }
}
